/* eslint-disable array-callback-return */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { RowDataUpdatedEvent } from 'wdna-grid-table/lib/types';
import Table, { TableButtonsConfig } from 'wdna-components/lib/table/Table';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import { WidgetGrid, JarvisWidget } from 'wdna-components/lib';

import { ContextType, FilterContext } from '../../../../types';

interface Props {
  rowId?: number;
}

interface State {
  loading: boolean;
  update: string;
  showGrid: boolean;
  showModal: boolean;

  modalData: any;
}

export default class Container extends React.Component<Props, State> {
  private mounted: boolean;
  private buttons: TableButtonsConfig;

  public static contextType: React.Context<ContextType> = FilterContext;
  public context: React.ContextType<typeof FilterContext> | undefined;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;
    this.buttons = {
      info: true,
    };

    this.state = {
      loading: false,
      update: window.getStr(),
      showGrid: false,
      showModal: false,

      modalData: {},
    };
  }

  public componentDidMount(): void {
    this.mounted = true;
  }

  public shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    return this.context?.parentState.update !== nextState.update;
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public setLocalState = (nextState: Partial<State>, callback?: (() => void)): void => {
    if (this.mounted) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...nextState,
      }), callback);
    }
  };

  public onInfo = (value: any): void => {
    this.setLocalState({
      update: window.getStr(),
      showModal: true,
      modalData: value,
    });
  };

  public onCloseModal = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showModal: false,
    });
  };

  public rowDataUpdated = (_event: RowDataUpdatedEvent): void => {
    this.setLocalState({
      update: window.getStr(),
      showGrid: true,
    });
  };

  public getAlias = (names: string[] = []): Record<string, string> => {
    const columnAlias: Record<string, string> = {
      date: 'Date',
      sensorId: 'Sensor Id',
      gatewayId: 'Gateway Id',
    };
    names.forEach((item: string, idx: number) => {
      columnAlias[`d${(`000${idx}`).slice(-2)}`] = item;
    });

    return columnAlias;
  };

  public render(): JSX.Element {
    const variableNames: string[] = this.context?.parentState.data3;
    const columnAlias: Record<string, string> = this.getAlias(variableNames);
    const columnsToHide: string[] = [
      'timestamp',
      'chain'
    ];
    const columnStyles: Record<string, any> = {
      date: { textAlign: 'center' },
    };
    const customColumnsDefs: Record<string, any> = {
      date: { suppressSizeToFit: false, minWidth: 160, maxWidth: 160 },
    };

    const { loading, showGrid, showModal, modalData } = this.state;

    return (
      <div id="content" className="content">
        <WidgetGrid>
          <article className="col-sm-12 col-md-12 col-lg-12">
            <JarvisWidget
              editbutton={false}
              togglebutton={false}
              colorbutton={false}
              deletebutton={false}
              custombutton={false}
              fullscreenbutton={false}
            >
              <div id="content" style={{ visibility: showGrid ? 'visible' : 'hidden' }}>
                <Table
                  data={this.context?.parentState.data || []}
                  alias={columnAlias}
                  customCellStyles={columnStyles}
                  hiddenCols={columnsToHide}
                  buttons={this.buttons}
                  onInfo={this.onInfo}
                  loading={loading}
                  rowDataUpdated={this.rowDataUpdated}
                  customColumnsDefs={customColumnsDefs}
                  height="calc(75vh - 6px)"
                  pagination={false}
                  showRowNumber
                />
                <ContainerModal
                  fullScreenButton={false}
                  show={showModal}
                  title={`Reading Details - ${modalData?.date?.toLocaleString() || ''}`}
                  modalClass="selector-modal-70"
                  onClose={this.onCloseModal}
                  footerButtons={[
                    {
                      text: 'OK',
                      className: 'btn btn-primary',
                      onClick: this.onCloseModal,
                    },
                  ]}
                >
                  <b>Chain: </b><br />
                  {modalData && modalData.chain}
                </ContainerModal>
              </div>
            </JarvisWidget>
          </article>
        </WidgetGrid>
      </div>
    );
  }
}
